import { useEffect, useState } from 'react';
import useQueryStrings from '../useQueryStrings';
import { useLocation } from 'react-router-dom';
import {
  convertFilterFromQSToLocalFilter,
  createSettersObjectFromFilters,
  getInitFiltersValues
} from './utils';

const useSyncedQSFilters = (filters = {}) => {
  const location = useLocation();
  const [queryParams, updateQueryParam] = useQueryStrings();
  const [syncedFilters, setSyncedFilters] = useState(
    getInitFiltersValues(filters)
  );
  const [isFilterSynced, setSynced] = useState(false);

  const [setters] = useState(
    createSettersObjectFromFilters(filters, setSyncedFilters, updateQueryParam)
  );

  useEffect(() => {
    setSynced(false);
  }, [location.pathname]);

  const updateFiltersFromQuerystring = () => {
    const queryParamsEntries = Object.entries(queryParams);
    if (queryParamsEntries.length) {
      queryParamsEntries
        .filter(([key]) => key in filters)
        .forEach(([key, value]) => {
          setSyncedFilters(prev => ({
            ...prev,
            teams: null,
            [key]: convertFilterFromQSToLocalFilter(filters[key], value)
          }));
        });
      setSynced(true);
    }
  };

  useEffect(() => {
    updateFiltersFromQuerystring();
  }, [filters]);

  return {
    syncedFilters,
    setters,
    isFilterSynced
  };
};

export default useSyncedQSFilters;
